import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssueFieldSchemeRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-field-scheme',
	path: '/jira/settings/issues/field-schemes/:schemeId',
	exact: true,
};
